import isEmpty from 'lodash/fp/isEmpty';
import { useSelector } from 'react-redux';

import { videoFolderSelectors } from '../../../../store/modules/videoFolder';

const useMyProjectsEmptyList = () => {
  const folders = useSelector(videoFolderSelectors.selectCurrentFolders);
  const projects = useSelector(videoFolderSelectors.selectCurrentProjects);

  const isListEmpty = !folders || !projects || isEmpty([...folders, ...projects]);

  return [isListEmpty] as const;
};

export default useMyProjectsEmptyList;
